import Labels from './components/labels';
import Autocomplete from './components/autocomplete';
import International from './components/international';

Labels.init();
Autocomplete.init();
International.init();
